<template>
  <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4" >
            <v-card class="elevation-12">
              <v-toolbar color="orange darken-4" dark flat>
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    v-model="user_name"
                    prepend-icon="mdi-account-cowboy-hat"
                    type="text"  
                    :rules="[rules.required]"                  
                  />
                  <v-text-field
                    id="password"
                    label="Password"                    
                    v-model="password"
                    prepend-icon="mdi-lock"
                    :append-icon="showPsw ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPsw ? 'text' : 'password'"
                    :rules="[rules.required]"
                    @click:append="showPsw = !showPsw"                    
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />                
                <v-btn color="orange darken-4" class="ma-2 white--text" @click="login()" :disabled="!user_name ||!password">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
    data () {
        return {
            showPsw: false,
            user_name: '',
            password: '',
            rules: {
                required: value => !!value || 'Required.'
            }
        }
    },
    created () {},
    computed: {
        ...mapState([
        'isLoading',
        ])
    },
    methods: {
        login (){            
            this.$store.dispatch('vpn_login',{"user_name":this.user_name,"password":this.password})
        }
       
    }
};
</script>